import React from "react";
import { connect } from "react-redux";

import Button from "../../components/Button/Button";

import "./LoginOnly.css";

const loginOnly = (props) => {
  let content = null;

  if (props.userId) {
    content = props.children;
  } else {
    content = (
      <div className="LoginOnly">
        <h4>Please log in to access THE Virtual Performance Center.</h4>
        <br />
        <Button buttonType="Primary" size="sm" to="/auth">
          Login
        </Button>
      </div>
    );
  }
  return <React.Fragment>{content}</React.Fragment>;
};

const mapStateToProps = (state) => {
  return {
    userId: state.userId,
  };
};

export default connect(mapStateToProps)(loginOnly);
